/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as AdminDefs from '../../../com/atproto/admin/defs.defs'
import * as RepoStrongRef from '../../../com/atproto/repo/strongRef.defs'
import * as ConvoDefs from '../../../chat/bsky/convo/defs.defs'

const $nsid = 'tools.ozone.inbox.getReport'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  id: /*#__PURE__*/ l.integer(),
  did: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'did' })),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  report: /*#__PURE__*/ l.ref<ReportView>((() => reportView) as any),
  resolution: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<ResolutionView>((() => resolutionView) as any),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get a moderation report submitted by the authenticated account to this moderation service. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ['NotFound'])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

type ReportView = {
  $type?: 'tools.ozone.inbox.getReport#reportView'

  /**
   * Report ID (report table ID), used by Ozone's report detail page.
   */
  id: number

  /**
   * DID of the moderation service that received the report.
   */
  src: l.DidString
  reason?: string

  /**
   * Raw record JSON for the subject, when the subject is a record and the record is available.
   */
  record?: l.LexMap
  status: 'pending' | 'resolved' | l.UnknownString
  subject:
    | l.$Typed<AdminDefs.RepoRef>
    | l.$Typed<RepoStrongRef.Main>
    | l.$Typed<ConvoDefs.MessageRef>
    | l.$Typed<ConvoDefs.ConvoRef>
    | l.Unknown$TypedObject
  createdAt: l.DatetimeString
  updatedAt: l.DatetimeString

  /**
   * The exact fully-qualified reason NSID submitted with and stored on the report.
   */
  reasonType: string
}

export type { ReportView }

const reportView = /*#__PURE__*/ l.typedObject<ReportView>(
  $nsid,
  'reportView',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.integer(),
    src: /*#__PURE__*/ l.string({ format: 'did' }),
    reason: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxLength: 20000, maxGraphemes: 2000 }),
    ),
    record: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.lexMap()),
    status: /*#__PURE__*/ l.string<{ knownValues: ['pending', 'resolved'] }>(),
    subject: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<AdminDefs.RepoRef>(
          (() => AdminDefs.repoRef) as any,
        ),
        /*#__PURE__*/ l.typedRef<RepoStrongRef.Main>(
          (() => RepoStrongRef.main) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.MessageRef>(
          (() => ConvoDefs.messageRef) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.ConvoRef>(
          (() => ConvoDefs.convoRef) as any,
        ),
      ],
      false,
    ),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    updatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    reasonType: /*#__PURE__*/ l.string(),
  }),
)

export { reportView }

type ResolutionView = {
  $type?: 'tools.ozone.inbox.getReport#resolutionView'
  scope?: 'network' | 'app' | 'labelOnly' | l.UnknownString
  outcome: 'actionTaken' | 'noAction' | 'other' | l.UnknownString
  resolvedAt: l.DatetimeString

  /**
   * Public action associated with this report's resolution. See the public action vocabulary table.
   */
  actionTaken?: string
}

export type { ResolutionView }

const resolutionView = /*#__PURE__*/ l.typedObject<ResolutionView>(
  $nsid,
  'resolutionView',
  /*#__PURE__*/ l.object({
    scope: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{
        knownValues: ['network', 'app', 'labelOnly']
      }>(),
    ),
    outcome: /*#__PURE__*/ l.string<{
      knownValues: ['actionTaken', 'noAction', 'other']
    }>(),
    resolvedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    actionTaken: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  }),
)

export { resolutionView }
